import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as DeviceActions from '../_actions/device';
import { Device } from '../_models';

export interface DeviceState extends EntityState<Device> {
  loaded: boolean;
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Device> = createEntityAdapter<Device>();

const initialState: DeviceState = adapter.getInitialState({
  loaded: false,
  loading: false,
  error: null,
});

const deviceReducer = createReducer(
  initialState,

  on(DeviceActions.loadDevices, (state) => ({
    ...state,
    loaded: false,
    loading: true,
    error: null,
  })),

  on(DeviceActions.loadDevicesSuccess, (state, { devices }) =>
    adapter.setAll(devices, { ...state, loading: false, loaded: true })
  ),

  on(DeviceActions.loadDevicesFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    loading: false,
    error,
  })),

  on(DeviceActions.addDeviceSuccess, (state, { device }) => adapter.addOne(device, state)),

  on(DeviceActions.updateDeviceSuccess, (state, { device }) => adapter.upsertOne(device, state)),

  on(DeviceActions.deleteDeviceSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    DeviceActions.addDeviceFailure,
    DeviceActions.updateDeviceFailure,
    DeviceActions.deleteDeviceFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: DeviceState | undefined, action: Action) {
  return deviceReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
